module.exports = __webpack_public_path__ + "static/media/logo.eb0f1d7d.webp";